/**
 * @created on 2017/9/19
 * @author laixinyu <laixinyualex@gmail.com>
 **/
import Bridge from 'src/frontend-lib/lib/Bridge'
import { getRunningEnv } from 'src/frontend-lib/tools/getPlatform'

const platform = require('src/frontend-lib/tools/getPlatform').getPlatform()

/**
 *
 * @param str
 */
module.exports.getRunTime = str => {
  let env = getRunningEnv().env
  let result

  result = str.replace(/\./, `${env === '' ? '' : '-'}${env}.`)

  console.log(result)
  return result
}

module.exports.getMP = () => {
  let userAgent = navigator.userAgent
  if (userAgent.indexOf('AlipayClient') > -1) {
    // 支付宝小程序
    return true
  } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
    // QQ 小程序
    return true
  } else if (/miniProgram/i.test(userAgent)) {
    // 微信小程序
    return true
  } else if (/toutiaomicroapp/i.test(userAgent)) {
    // 头条小程序
    return true
  } else if (/swan/i.test(userAgent)) {
    // 百度小程序
    return true
  } else {
    return false
  }
}

/**
 * 数字超过1000自动换算成k并且保留一位小数
 * @created on 2017/9/18
 * @author laixinyu <laixinyualex@gmail.com>
 **/

module.exports.unitConversion = number => {
  let num = Number(number)

  if (num >= 1000) {
    num = num / 1000

    return num.toFixed(1) + 'k'
  } else {
    return num
  }
}

/**
 * 数字超过1000自动换算成k并且保留一位小数
 * @created on 2017/9/18
 * @author laixinyu <laixinyualex@gmail.com>
 **/

module.exports.unitConversion = number => {
  let num = Number(number)

  if (num >= 1000) {
    num = num / 1000

    return num.toFixed(1) + 'k'
  } else {
    return num
  }
}

/**
 * 保留N位小数,不够补0
 * @param {Number} num
 * @param {Number} zeroCount
 */
module.exports.toFixed = (num, zeroCount = 2) => {
  var result = parseFloat(num)
  if (isNaN(result)) {
    throw new Error('传递参数错误，请检查！')
  }
  result = Math.round(num * 100) / 100
  var s_x = result.toString()
  var pos_decimal = s_x.indexOf('.')
  if (pos_decimal < 0) {
    pos_decimal = s_x.length
    s_x += '.'
  }
  while (s_x.length <= pos_decimal + zeroCount) {
    s_x += '0'
  }
  return s_x
}

/**
 * 跳转到壹心理app打开页面，如果无壹心理app则跳去下载页面
 * @param href
 */
const goApp = href => {
  let src = `yixinli://${href}`
  let ifr

  let UA = window.navigator.userAgent.toUpperCase()

  // 判断微信环境
  if (/MICROMESSENGER/i.test(UA)) {
    if (window.toast) {
      window.toast('微信用户需要点击右上角菜单，使用“浏览器”打开~', 3000)
    } else {
      alert('微信用户需要点击右上角菜单，使用“浏览器”打开~')
    }

    return
  }
  if (/(IPHONE|IPAD|IPOD|IOS)/i.test(UA)) {
    window.location.href = src
  } else {
    ifr = document.createElement('iframe') //open_question_detail?question_id=123
    ifr.src = src
    ifr.style.display = 'none'

    document.body.appendChild(ifr)
  }

  window.setTimeout(function() {
    if (ifr) document.body.removeChild(ifr)
    window.location.href =
      '//a.app.qq.com/o/simple.jsp?pkgname=com.xinli.yixinli'
  }, 2000)
}
module.exports.goApp = goApp

/**
 * 移动端跳转到下载，app内调协议更新
 */
module.exports.updateOrDownLoadApp = () => {
  const ua = window.navigator.userAgent
  const isApp = platform.isYixinliApp || platform.isCeShiApp
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  if (isApp) {
    let bridge = new Bridge()
    const _version = GetQueryString('_version', window.location.hash)
    // APP 5.2.1 才有执行更新方法（doUpgrade）
    if (versionfunegt(_version, '5.2.1')) {
      bridge.call('doUpgrade')
    } else {
      if (isAndroid) {
        // bridge.call('openWebView', {
        //   url: 'http://app-global.pgyer.com/3032d1cee33cd139f310f9f1da85caa9.apk?attname=yixinli-debug-20180816-175409.apk&sign=730cd838ae4b4c83f6af335e669bd51c&t=5b7671c5', // sdk原型上链接
        //   isCurrentPageOpen: 0
        // })
        const iframe = document.createElement('iframe')
        const src =
          'http://xinli001-file.oss-cn-hangzhou.aliyuncs.com/android_patch/yixinli.apk'
        iframe.src = src
        iframe.style = `width:0;height:0;overflow:hidden;position: absolute;`
        document.body.appendChild(iframe)
        setTimeout(() => document.body.removeChild(iframe), 2000)
      } else {
        // ios从浏览器打开应用宝
        // const a = document.createElement('a')
        const href =
          'http://a.app.qq.com/o/simple.jsp?open_by_broswer=1&pkgname=com.xinli.yixinli'
        bridge.call('openWebview', {
          url: href,
          isOpenByBrowser: 1
        })
        // a.href = href
        // document.body.appendChild(a)
        // a.click()
        // document.body.removeChild(a)
      }
    }
  } else {
    goApp()
  }
}

// 跳转到心理FM打开页面，如果无心理FM则跳去下载页面
module.exports.goFmApp = href => {
  let src = `xinlifm://${href}`
  let ifr

  let UA = window.navigator.userAgent.toUpperCase()

  // 判断微信环境
  if (/MICROMESSENGER/i.test(UA)) {
    window.location.href =
      'http://a.myapp.com/o/simple.jsp?pkgname=com.xinli.fm'
  }

  if (/(IPHONE|IPAD|IPOD|IOS)/i.test(UA)) {
    window.location.href = src
  } else {
    ifr = document.createElement('iframe') //open_question_detail?question_id=123
    ifr.src = src
    ifr.style.display = 'none'

    document.body.appendChild(ifr)
  }
  window.setTimeout(function() {
    if (ifr) document.body.removeChild(ifr)
    if (/(IPHONE|IPAD|IPOD|IOS)/i.test(UA)) {
      var newA = document.createElement('a')
      newA.setAttribute('id', 'newA')
      newA.setAttribute(
        'href',
        'http://a.myapp.com/o/simple.jsp?pkgname=com.xinli.fm&open_by_broswer=1'
      )
      document.body.appendChild(newA)
      document.getElementById('newA').click()
    } else {
      window.location.href =
        'http://a.myapp.com/o/simple.jsp?pkgname=com.xinli.fm'
    }
  }, 2000)
}

/**
 * 动态加载js
 * @param url
 * @param callback
 */
module.exports.loadScript = (url, callback) => {
  let script = document.createElement('script')
  script.type = 'text/javascript'
  if (typeof callback != 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = function() {
        callback()
      }
    }
  }
  script.src = url

  document.body.appendChild(script)
}

module.exports.debounce = (action, idle) => {
  let last = null
  return function() {
    let ctx = this,
      args = arguments
    clearTimeout(last)
    last = setTimeout(function() {
      action.apply(ctx, args)
    }, idle)
  }
}

// 获取系统平台
module.exports.getSystem = function() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //ios
    return 'Ios'
  } else if (/(Android)/i.test(navigator.userAgent)) {
    //android
    return 'Android'
  }
}

const versionfunegt = function(ver1, ver2) {
  if (!ver1 || !ver2) return
  const version1pre = parseFloat(ver1)
  const version2pre = parseFloat(ver2)
  const version1next = +ver1.replace(version1pre + '.', '')
  const version2next = +ver2.replace(version2pre + '.', '')
  if (version1pre > version2pre) {
    return true
  } else if (version1pre < version2pre) {
    return false
  } else {
    if (version1next >= version2next) {
      return true
    } else {
      return false
    }
    // return version1next >= version2next
  }
}
module.exports.versionfunegt = versionfunegt

// 获取URL 中 Query
export function GetQueryString(name, url) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = (url || window.location.search.substr(1)).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 *
 * @param val Storage名
 * @param key 键名
 * @param day 过期时间  单位：天
 * @param writable  是否可以set
 * @returns {boolean} false:未过期   true:已过期
 * @constructor
 */
module.exports.HandleExpiresStorage = (val, key, day, writable = false) => {
  let StorageObj = JSON.parse(localStorage.getItem(val))
  let StorageMap = new Map()
  const curTime = Date.now()
  for (let key in StorageObj) {
    StorageMap.set(key, StorageObj[key])
  }
  let keyValue = StorageMap.get(key)
  if (keyValue) {
    let interval = curTime - keyValue
    if (interval < 0) return false //未过期
  }
  if (writable) {
    localStorage.removeItem(val)
    StorageMap.set(key, curTime + day * 1000 * 86400)
    let objFromMap = {}
    for (let [k, v] of StorageMap) {
      objFromMap[k] = v
    }
    localStorage.setItem(val, JSON.stringify(objFromMap))
  }
  return true
}



// WEBPACK FOOTER //
// ./src/libs/utils.js